export type LiveEditorColorEditorType = "donation_form" | "ticketing" | "org_page";

export const LIVE_EDITOR_PRESET_COLORS = [
  "#F87878",
  "#F7BD7A",
  "#F6E186",
  "#A4EB99",
  "#76E0CF",
  "#A1CFFB",
  "#E4AEFB",
  "#FA85B0",
];
export const LIVE_EDITOR_BLACK_COLOR = "#000000";
export const LIVE_EDITOR_RAINBOW_GRADIENT =
  "conic-gradient(from 180deg at 50% 50%, #F87878 0deg, #F6E186 46.79999828338623deg, #F7BD7A 93.59999656677246deg, #A4EB99 140.3999948501587deg, #76E0CF 187.19999313354492deg, #A1CFFB 233.99999141693115deg, #8C8CFC 273.59999656677246deg, #E4AEFB 327.60000944137573deg, #FA85B0 360deg)";

const SELECTABLE_PRESET_COLORS = [...LIVE_EDITOR_PRESET_COLORS, LIVE_EDITOR_BLACK_COLOR];

export const findLiveEditorPresetColor = (color: string) =>
  SELECTABLE_PRESET_COLORS.find((presetColor) => presetColor.toLowerCase() === color.toLowerCase());

interface ColorChangedEventInput {
  color: string;
  colorOnStepArrival: string;
  editorType: LiveEditorColorEditorType;
}

export const getColorChangedEventProperties = ({ color, colorOnStepArrival, editorType }: ColorChangedEventInput) => ({
  color,
  is_custom: !findLiveEditorPresetColor(color) && color.toLowerCase() !== colorOnStepArrival.toLowerCase(),
  editor_type: editorType,
});
